module.exports = __webpack_public_path__ + "static/media/home-onepage-box-image-02.42fa45fc.gif";